import {
    validate_distancia,
    validate_emails,
    validate_Lote,
    validate_viaje,
    validateEmptyArray,
    validatorAlphaNumSpaces,
    validatorCreditCard,
    validatorCSV,
    validatorNormalInteger,
    validatorPassword,
    validatorPositive,
    validatorSecDae,
    validatorTemp,
    validatorUrlValidator,
} from './validators'
import { extend, localize } from 'vee-validate'
// ////////////////////////////////////////////////////////
// General
// ////////////////////////////////////////////////////////

import i18n from '@/libs/i18n'
import en from 'vee-validate/dist/locale/en.json'
import es from 'vee-validate/dist/locale/es.json'
import {
    alpha as rule_alpha,
    alpha_dash as rule_alpha_dash,
    alpha_num as rule_alpha_num,
    alpha_spaces as rule_alpha_spaces,
    between as rule_between,
    confirmed as rule_confirmed,
    digits as rule_digits,
    double as rule_double,
    email as rule_email,
    integer as rule_integer,
    length as rule_length,
    max as rule_max,
    max_value as rule_max_value,
    // decimal as rule_decimal,
    mimes as rule_mimes,
    min as rule_min,
    min_value as rule_min_value,
    numeric as rule_numeric,
    regex as rule_regex,
    required as rule_required,
    size as rule_size,
} from 'vee-validate/dist/rules'

export const required = extend('required', rule_required)

export const email = extend('email', rule_email)

export const min = extend('min', rule_min)

export const confirmed = extend('confirmed', rule_confirmed)

export const regex = extend('regex', rule_regex)

export const between = extend('between', rule_between)

export const alpha = extend('alpha', rule_alpha)

export const integer = extend('integer', rule_integer)

export const digits = extend('digits', rule_digits)

export const alphaDash = extend('alpha-dash', rule_alpha_dash)

export const alphaNum = extend('alpha-num', rule_alpha_num)

export const alphaSpaces = extend('alpha-spaces', rule_alpha_spaces)

export const length = extend('length', rule_length)

export const double = extend('double', rule_double)

export const numeric = extend('numeric', rule_numeric)

export const max = extend('max', rule_max)

export const max_value = extend('max_value', rule_max_value)

export const positive = extend('positive', {
    validate: validatorPositive,
    message: 'Please enter positive number!',
})

export const normal = extend('normal', {
    validate: validatorNormalInteger,
    message: 'Ingrese un entero mayor que 0!',
})

export const credit = extend('credit-card', {
    validate: validatorCreditCard,
    message: 'It is not valid credit card!',
})

export const password = extend('password', {
    validate: validatorPassword,
    message: field => i18n.t('password', { field }),
})

export const url = extend('url', {
    validate: validatorUrlValidator,
    message: () => i18n.t('ivalidUrl'),
})

export const csv = extend('csv', {
    validate: validatorCSV,
    message: 'Ingrese valores separados por ","!',
})
export const lote = extend('lote', {
    validate: validate_Lote,
    messages: 'Lote invalido',
})
export const temperature = extend('temperature', {
    validate: validatorTemp,
    messages: 'Temperatura inválida',
})

export const distancia = extend('distancia', {
    validate: validate_distancia,
    messages: 'distancia invalida',
})

export const gt = extend('gt', {
    params: ['target'],
    validate(value, { target }) {
        return value > target
    },
    message: 'El valor debe ser mayor a {target}',
})

export const min_value = extend('min_value', rule_min_value)

export const mimes = extend('mimes', rule_mimes)

export const size = extend('size', rule_size)

export const alpha_num_spaces = extend('alpha_num_spaces', {
    validate: validatorAlphaNumSpaces,
    messages: 'Solo letras,numeros,espacios,guiones y subguiones.',
})

export const secuencia_dae = extend('secuencia_dae', {
    validate: validatorSecDae,
    message: 'La secuencia DAE está incompleta o es inválida',
})
export const viaje = extend('viaje', {
    validate: validate_viaje,
    messages: 'N° de Viaje invalido',
})
/// Correos separados por ';'
export const emails = extend('emails', {
    validate: validate_emails,
    messages: 'Solo correos separados por ; y sin espacios',
})

export const emptyarray = extend('emptyarray', {
    validate: validateEmptyArray,
    message: 'Debe seleccionar al menos uno.',
})

// export const decimal = extend('decimal', rule_decimal)

// Install English and Arabic localizations.
localize({
    en: {
        messages: en.messages,
        names: {
            email: 'Email',
            password: 'Password',
        },
        fields: {
            password: {
                min: '{_field_} is too short, you want to get hacked?',
            },
        },
    },
    es: {
        messages: es.messages,
        names: {
            email: 'Correo',
            password: 'Contraseña',
        },
        fields: {
            password: {
                min: '{_field_} es demasiado corto, quieres ser hackeado?',
            },
        },
    },
})
// ////////////////////////////////////////////////////////
// NOTE:
// Quasar validation for reference only
// Remove this note once development is finished and make sure to
// to convert all of them in veevalidate version
// ////////////////////////////////////////////////////////

// export const required = (val) => {
//   return (val && val.length > 0) || '*Field is required'
// }

// export const required_obj = (obj) => {
//   if (obj === null || obj === undefined) return '*Field is required'
//   return (Object.entries(obj).length > 0 && obj.constructor === Object) || '*Field is required'
// }

// export const no_blank_spaces_arr = (arr) => {
//   return arr.every(val => (val.trim() && val.trim().length > 0)) || 'Blank Spaces are not allowed'
// }

// export const url = val => {
//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true

//   // Used
//   // https://stackoverflow.com/questions/4314741/url-regex-validation

//   // Other
//   // https://stackoverflow.com/questions/5717093/check-if-a-javascript-string-is-a-url
//   // https://www.w3resource.com/javascript-exercises/javascript-regexp-exercise-9.php
//   // https://www.geeksforgeeks.org/how-to-validate-url-using-regular-expression-in-javascript/

//   /* eslint-disable no-useless-escape */
//   const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/
//   /* eslint-enable no-useless-escape */
//   return re.test(val) || 'URL is invalid'
// }

// export const date = val => {

//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true

//   // https://github.com/quasarframework/quasar/blob/dev/ui/src/utils/patterns.js
//   return /^-?[\d]+\/[0-1]\d\/[0-3]\d$/.test(val) || 'Date is invalid'
// }

// export const max = (val, max) => {

//   // If blank return
//   if (val === undefined || val === null) return true

//   return val.length <= max || `More than ${max} characters are not allowed`
// }

// export const max_arr = (val, max) => {
//   return val.length <= max || `More than ${max} values are not allowed`
// }

// export const min = (val, min) => {

//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true

//   return val.length >= min || `Minimum ${min} characters are required`
// }

// export const num_range = (val, min, max) => {

//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true

//   const msg = 'Value is invalid'
//   if (min === null) return val <= max || msg
//   else if (max === null) return val >= min || msg
//   else return (val >= min && val <= max) || msg
// }
